// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root___M_9g","header":"MergedInvoice_header__2s_BL"};